import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-help-documentos',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './help-documentos.component.html',
  styleUrl: './help-documentos.component.css'
})
export class HelpDocumentosComponent {
  passos = [
    { titulo: '1. Selecionar a perícia', texto: 'Abra Perícia e escolha o processo/cliente que será trabalhado.' },
    { titulo: '2. Preencher os blocos de honorários', texto: 'Na aba Honorários, revise valores, horas, despesas e observações.' },
    { titulo: '3. Salvar a estimativa', texto: 'Clique em Salvar para gravar os dados no banco.' },
    { titulo: '4. Abrir o preview', texto: 'Escolha Preview Juízo, Preview Assistente ou Preview Extrajudicial.' },
    { titulo: '5. Exportar', texto: 'Na janela de preview, selecione PDF, Word ou HTML e clique em Exportar proposta.' }
  ];
}
